import { PRE_SHIPMENT_UI } from 'actions/personalize';
import { isMobile, p13nServiceDecisions } from "../../helpers/ApplicationHelper";

export default (state = null, action) => {
    switch (action.type) {
        case PRE_SHIPMENT_UI:
            if ( action.error ) {
                window && window.rollbar && window.rollbar.error('Personalizer pre-shipment-ui error: ' + action.payload.toString())
                state = state || "default"
            } else {
                state = action.payload.data.preShipmentUi;
            }
    }

    return state;
}
